module.exports = __webpack_public_path__ + "static/img/banner_logo.b32f64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/banner_logo.png
// module id = m5Em
// module chunks = 12